export const camelCaseToSnake = (val: string): string => {
  const val2 = val
    .replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`)
    .replace(/^_/, '');
  return val2;
};

export const camelCaseToHuman = (val: string): string => {
  const snakeCase = val.replace(/([a-z])([A-Z])/g, '$1 $2');
  return snakeCase.charAt(0).toUpperCase() + snakeCase.slice(1);
};
